import { Lookup } from "../../common/Lookup";

export class CitesImporterDetails{
    importerName?: string;
    importerCountry?: Lookup;
    // importerCityName?: string;
    importerAddress?: string;
    // importerPhone?: string;
    // importerEmail?: string;
    // importerPOBox?: string;
    // importerFax?: string;
}